<template>

    <div class="copybox" :class="{ dark: dark }">
        <div class="copybox-body">
            <v-button size="xs" btn-style="white" title="Copy" @click.native="copyText">
                <i v-if="!copied" class="fas fa-clipboard"></i>
                <i v-else class="fas fa-clipboard-check text-success"></i>
            </v-button>
            <span ref="textToCopy"><slot></slot></span>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .copybox {
        display: table;
        table-layout: fixed;
        width: 100%;
        word-wrap: break-word;
        &.dark .copybox-body {
            background: $color-bg;
            border: none;
        }
        .copybox-body {
            @include font-medium(13px);
            background: #fff;
            border: 1px solid $color-rule;
            border-radius: 3px;
            color: $color-text;
            line-height: 1.6em;
            min-height: 50px;
            min-width: 100px;
            padding: 15px 50px 15px 15px;
            position: relative;
            text-align: left;
            white-space: normal;
            button {
                margin: 5px;
                position: absolute;
                right: 0;
                top: 0;
            }
        }
    }

</style>

<script>

export default {

    props: {
        dark: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            copied: false,
        }
    },

    methods: {

        copyText() {
            let el = this.$refs.textToCopy;
            navigator.clipboard.writeText(el.innerHTML)
                .then(() => {
                    this.$store.commit('setAlertSuccess', this.$t('message.copied'));
                    this.copied = true;
                })
                .catch(() => {
                    this.$store.commit('setAlertError', 'Unable to copy text.');
                });
        },

    },

}

</script>
